import { Component, input, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '../../services/i18n.service';
import { Breadcrumb } from '../../models/breadcrumb.model';
import { NgClass } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { LP_UI_CONFIG } from '../../core/tokens';

@Component({
  selector: 'app-breadcrumbs',
  imports: [NgClass, NzIconModule],
  templateUrl: './breadcrumbs.html',
  styleUrls: ['./breadcrumbs.scss'],
})
export class BreadcrumbsComponent {
  object = input<any | null>(null); // as of now taking any as it is expecting a Location Type but from Plant list it is taking a Asset Type Where it creates a confusion between 2 types
  array = input<any[]>([]);
  isAsset = input<boolean>(false);
  showCurrent = input<boolean>(false);
  additionalBC = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  levels = input<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  bold = input<boolean>(true);
  shorten = input<number>();
  highlighted = input<number | string | null>(null);
  searchTealText = input<boolean>(false);
  //breadcrumbClicked = output<Breadcrumb>();

  private router = inject(Router);
  private i18n = inject(I18nService);
  public cfg = inject(LP_UI_CONFIG);

  breadcrumbs = computed<Breadcrumb[]>(() => {
    const obj = this.object();
    const arr = this.array();
    const highlight = this.highlighted();

    if (obj && obj.breadcrumbs) {
      const bc = obj.breadcrumbs
        .slice(this.isAsset() ? 2 : GLOBAL_CONSTANT.DEFAULT_INITIALIZER)
        .slice(-1 * this.levels())
        .map((item: any) => ({
          text: this.i18n.parse(item.objectName),
          isAsset: item.isAsset,
          isCountryOrRegion: !(item.curLayer && item.curLayer.charCodeAt(0) > 98),
          id: item.objectID,
          bold: item.searchTarget || highlight === item.objectID || highlight === item.objectName,
        }));

      if (this.showCurrent()) {
        bc.push({
          text: this.i18n.parse(obj.objectName),
          isAsset: obj.isAsset ?? false,
          isCountryOrRegion: !(obj.curLayer && obj.curLayer.charCodeAt(0) > 98),
          id:
            (obj.curLayer && obj.curLayer.charCodeAt(0) > 98
              ? obj.objectID
              : GLOBAL_CONSTANT.DEFAULT_INITIALIZER) ?? GLOBAL_CONSTANT.DEFAULT_INITIALIZER,
          bold:
            highlight === null ||
            obj.searchTarget ||
            highlight === obj.objectID ||
            highlight === obj.objectName,
        });
      }

      if (this.additionalBC() && this.additionalBC() !== GLOBAL_CONSTANT.EMPTY_STRING) {
        bc.push({
          text: this.additionalBC(),
          isAsset: false,
          isCountryOrRegion: false,
          id: GLOBAL_CONSTANT.DEFAULT_INITIALIZER,
          bold: highlight === this.additionalBC(),
        });
      }

      if (bc.length > GLOBAL_CONSTANT.DEFAULT_INITIALIZER && !bc.find((item: any) => item.bold)) {
        bc[bc.length - 1].bold = true;
      }

      return bc;
    } else if (arr && arr.length > GLOBAL_CONSTANT.DEFAULT_INITIALIZER) {
      const bc = arr.map((item) => ({
        text: this.i18n.parse(item.objectName),
        isAsset: item.isAsset,
        isCountryOrRegion: !(item.curLayer && item.curLayer.charCodeAt(0) > 98),
        id: item.objectID,
        bold: item.searchTarget || highlight === item.objectID || highlight === item.objectName,
      }));

      if (bc.length > 0 && !bc.find((item) => item.bold)) {
        bc[bc.length - 1].bold = true;
      }

      return bc;
    }

    return [];
  });

  navTo(breadcrumb: Breadcrumb) {
    if (!breadcrumb || !breadcrumb.id) return;
    if (breadcrumb.bold && this.cfg.appName === 'ia') {
      this.router.navigate(['asset', this.object().objectID]);
    } else if (breadcrumb.isAsset) {
      this.router.navigate(['asset', breadcrumb.id, -1]);
    } else if (breadcrumb.isCountryOrRegion) {
      this.router.navigate(['home', 'list', breadcrumb.id]);
    } else {
      this.router.navigate(['plant', breadcrumb.id]);
    }
  }
}
